const ColumnsIcon = ({ color = '#141B34', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill="none">
			<defs />
			<path
				fill={color}
				d="M2.086,5.5 C2.086,3.429 3.765,1.75 5.836,1.75 L18.836,1.75 C20.907,1.75 22.586,3.429 22.586,5.5 L22.586,18.5 C22.586,20.571 20.907,22.25 18.836,22.25 L5.836,22.25 C3.765,22.25 2.086,20.571 2.086,18.5 Z M15.086,20.75 L15.086,3.25 L9.586,3.25 L9.586,20.75 Z M16.586,20.75 L18.836,20.75 C20.079,20.75 21.086,19.743 21.086,18.5 L21.086,5.5 C21.086,4.257 20.079,3.25 18.836,3.25 L16.586,3.25 Z M5.836,3.25 C4.593,3.25 3.586,4.257 3.586,5.5 L3.586,18.5 C3.586,19.743 4.593,20.75 5.836,20.75 L8.086,20.75 L8.086,3.25 Z"
			/>
		</svg>
	);
};

export default ColumnsIcon;
